var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 292.442,
    height: 141.019,
    viewBox: "0 0 292.442 141.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24496",
    "data-name": "Rectangle 24496",
    width: 169.442,
    height: 115.221,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24493",
    "data-name": "Rectangle 24493",
    width: 144.1,
    height: 3.594,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24494",
    "data-name": "Rectangle 24494",
    width: 7.555,
    height: 3.449,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24493-2",
    "data-name": "Rectangle 24493",
    width: 144.1,
    height: 3.594,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24494-2",
    "data-name": "Rectangle 24494",
    width: 7.555,
    height: 3.449,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37832",
    "data-name": "Group 37832",
    transform: "translate(-475 -153.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37830",
    "data-name": "Group 37830",
    transform: "translate(475 153.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37829",
    "data-name": "Group 37829",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24489",
    "data-name": "Rectangle 24489",
    width: 169.442,
    height: 106.889,
    transform: "translate(0 8.332)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24490",
    "data-name": "Rectangle 24490",
    width: 169.442,
    height: 6.413,
    transform: "translate(0 0)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24491",
    "data-name": "Rectangle 24491",
    width: 169.442,
    height: 8.419,
    transform: "translate(0 6.413)",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37828",
    "data-name": "Group 37828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37827",
    "data-name": "Group 37827",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37823",
    "data-name": "Group 37823",
    transform: "translate(17.544 9.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37822",
    "data-name": "Group 37822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37821",
    "data-name": "Group 37821",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24492",
    "data-name": "Rectangle 24492",
    width: 144.1,
    height: 3.594,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75546",
    "data-name": "Path 75546",
    d: "M27.978,10.9a1.073,1.073,0,1,1-1.072-1.055A1.064,1.064,0,0,1,27.978,10.9",
    transform: "translate(-20.885 -7.96)",
    fill: "#c1d88c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75547",
    "data-name": "Path 75547",
    d: "M44.376,10.9A1.073,1.073,0,1,1,43.3,9.846,1.064,1.064,0,0,1,44.376,10.9",
    transform: "translate(-34.143 -7.96)",
    fill: "#f5e685"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75548",
    "data-name": "Path 75548",
    d: "M60.773,10.9A1.073,1.073,0,1,1,59.7,9.846,1.064,1.064,0,0,1,60.773,10.9",
    transform: "translate(-47.399 -7.96)",
    fill: "#bc6b50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37826",
    "data-name": "Group 37826",
    transform: "translate(5.383 9.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37825",
    "data-name": "Group 37825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37824",
    "data-name": "Group 37824",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75549",
    "data-name": "Path 75549",
    d: "M61.039,50v3.449l1.248-1.724Z",
    transform: "translate(-54.731 -49.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75550",
    "data-name": "Path 75550",
    d: "M29.354,53.445V50L28.106,51.72Z",
    transform: "translate(-28.106 -49.996)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37833",
    "data-name": "Group 37833"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24499",
    "data-name": "Rectangle 24499",
    width: 59,
    height: 49,
    transform: "translate(6 31.184)",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24500",
    "data-name": "Rectangle 24500",
    width: 59,
    height: 4,
    transform: "translate(6 83.184)",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24501",
    "data-name": "Rectangle 24501",
    width: 59,
    height: 4,
    transform: "translate(6 90.184)",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24502",
    "data-name": "Rectangle 24502",
    width: 86,
    height: 4,
    transform: "translate(76 44.184)",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24503",
    "data-name": "Rectangle 24503",
    width: 86,
    height: 4,
    transform: "translate(76 51.184)",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24504",
    "data-name": "Rectangle 24504",
    width: 86,
    height: 4,
    transform: "translate(76 58.184)",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24505",
    "data-name": "Rectangle 24505",
    width: 86,
    height: 22,
    transform: "translate(76 65.184)",
    fill: "#e8f3f1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37831",
    "data-name": "Group 37831",
    transform: "translate(597.558 179.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37829-2",
    "data-name": "Group 37829",
    transform: "translate(0.442)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24489-2",
    "data-name": "Rectangle 24489",
    width: 169.442,
    height: 106.889,
    transform: "translate(0 8.332)",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75551",
    "data-name": "Path 75551",
    d: "M0,0H169.442V6.413H0Z",
    transform: "translate(0 0)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24491-2",
    "data-name": "Rectangle 24491",
    width: 169.442,
    height: 8.419,
    transform: "translate(0 6.413)",
    fill: "#cbd3d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37828-2",
    "data-name": "Group 37828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37827-2",
    "data-name": "Group 37827",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37823-2",
    "data-name": "Group 37823",
    transform: "translate(17.544 9.503)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37822-2",
    "data-name": "Group 37822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37821-2",
    "data-name": "Group 37821",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24492-2",
    "data-name": "Rectangle 24492",
    width: 144.1,
    height: 3.594,
    transform: "translate(0 0)",
    fill: "#f4fafd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75546-2",
    "data-name": "Path 75546",
    d: "M27.978,10.9a1.073,1.073,0,1,1-1.072-1.055A1.064,1.064,0,0,1,27.978,10.9",
    transform: "translate(-20.885 -7.96)",
    fill: "#c1d88c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75547-2",
    "data-name": "Path 75547",
    d: "M44.376,10.9A1.073,1.073,0,1,1,43.3,9.846,1.064,1.064,0,0,1,44.376,10.9",
    transform: "translate(-34.143 -7.96)",
    fill: "#f5e685"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75548-2",
    "data-name": "Path 75548",
    d: "M60.773,10.9A1.073,1.073,0,1,1,59.7,9.846,1.064,1.064,0,0,1,60.773,10.9",
    transform: "translate(-47.399 -7.96)",
    fill: "#bc6b50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37826-2",
    "data-name": "Group 37826",
    transform: "translate(5.383 9.576)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37825-2",
    "data-name": "Group 37825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37824-2",
    "data-name": "Group 37824",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75549-2",
    "data-name": "Path 75549",
    d: "M61.039,50v3.449l1.248-1.724Z",
    transform: "translate(-54.731 -49.996)",
    fill: "#f4fafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75550-2",
    "data-name": "Path 75550",
    d: "M29.354,53.445V50L28.106,51.72Z",
    transform: "translate(-28.106 -49.996)",
    fill: "#f4fafd"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37834",
    "data-name": "Group 37834",
    transform: "translate(0.442 1.202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24499-2",
    "data-name": "Rectangle 24499",
    width: 59,
    height: 49,
    transform: "translate(6 31.184)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24500-2",
    "data-name": "Rectangle 24500",
    width: 59,
    height: 4,
    transform: "translate(6 83.184)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24501-2",
    "data-name": "Rectangle 24501",
    width: 59,
    height: 4,
    transform: "translate(6 90.184)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24502-2",
    "data-name": "Rectangle 24502",
    width: 86,
    height: 4,
    transform: "translate(76 44.184)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24503-2",
    "data-name": "Rectangle 24503",
    width: 86,
    height: 4,
    transform: "translate(76 51.184)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24504-2",
    "data-name": "Rectangle 24504",
    width: 86,
    height: 4,
    transform: "translate(76 58.184)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24505-2",
    "data-name": "Rectangle 24505",
    width: 86,
    height: 22,
    transform: "translate(76 65.184)",
    fill: "#bfddd9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Union_63",
    "data-name": "Union 63",
    d: "M-11130-10242h-20v-9h20v-4l13,8.5-13,8.5Z",
    transform: "translate(11731 10465)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_64",
    "data-name": "Union 64",
    d: "M-11130-10242h-20v-9h20v-4l13,8.5-13,8.5Z",
    transform: "translate(-10536 -10004.002) rotate(180)",
    fill: "#009081"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageRedirect);
export default __webpack_public_path__ + "static/media/page-redirect.25a9db1b161e42a2a2ea88e47961c243.svg";
export { ForwardRef as ReactComponent };